import React from 'react';
import PropTypes from 'prop-types';

import UserProfileCourse from './UserProfileCourse';

const UserProfileCourseList = props => {
  return (
    <div className="user-courses-container">
      {props.courses.map(x => (
        <UserProfileCourse key={x.id} course={x} />
      ))}
    </div>
  );
};

UserProfileCourseList.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      webinarsCount: PropTypes.number.isRequired,
      webinarsPassed: PropTypes.number.isRequired,
      type: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
};

export default UserProfileCourseList;
